Vue.component('ack-careers', {
    delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
    template: '#ack-careers',
    mixins: [languageMixins],
    created() {

    },
    mounted() {
      appLog.log('ack-careers mounted')
      this.setPageIsLoading(false)
    },
    created() {

    },
    props:{
      // dataIn: {
      //   type: Object,
      //   required: true
      // }

    },
    computed: {
      //...Vuex.mapGetters('sliders', ['slidersLists']),
      //...Vuex.mapGetters('articles', ['articlesArray']),
      isMobile(){
        return this.$parent.isMobile
      },
    },
    data() {
      return {
        pageId: 'careers-page',
        openedPositions: [
          {
            RowKey: '1',
            positionName: 'Part-Time Video Content Creator for Social Media',
            location: 'Neihu District, Taipei, Taiwan',
            contractType: 'Part-Time',
            contractLength: 'TBD',
            experience: 'TBD',
            workPosition: 'Work From Home',
            jobDescription: 'As our Part-Time Video Content Creator, you will play a crucial role in developing and executing our social media strategy, with a focus on creating engaging and informative video content for Instagram and TikTok. Your creativity and social media savvy will help us build our brand presence, engage with our audience, and drive our message home.',
            responsibilities: [
              'Develop and produce high-quality casual, creative video content tailored for Instagram and Facebook.',
              'Stay up-to-date with the latest social media trends, especially in the dental and 3D printing industries, to ensure content is relevant and engaging.',
              'Collaborate with our marketing team to align social media content with our overall marketing strategy and goals.',
              'Analyze and report on the performance of social media activities to guide future content creation.',
              'AB Testing',
              'Engage with our community by responding to comments and messages in a timely and professional manner.',
            ],
            requirements: [
              'Proven experience in creating engaging video content for social media.',
              'Strong understanding of social media trends and analytics.',
              'Creative thinker with excellent storytelling skills.',
              'Ability to work independently and manage content creation from concept to execution.',
              'Excellent communication and collaboration skills.',
              'Passionate about the dental industry and technology, specifically 3D printing, is a plus.',
              'Young, energetic, and proficient in navigating and leveraging social media platforms.',
              'Fluency in English is essential.'
            ],
            commitment: [
              'This is a part-time, remote position requiring a few hours of work per week.'
            ],

          },
        ],
        step: 0,
        selectedPosition: null,
      }
    },
    methods: {
      ...Vuex.mapActions(['setPageIsLoading']),
      //...Vuex.mapActions('sliders', ['getSlideList'])
      openJob(rowKey) {
        this.selectedJob = this.openedPositions.find(job => job.RowKey === rowKey)
        this.step = 1
      },
      closeJob() {
        this.selectedJob = null
        this.step = 0
      }



    },
    beforeDestroy() {

    },
    watch: {

      data1: {
        handler() {



        },
        deep: false
      }
    }
  })